<plc-background-screen
	class="plc-dialog-wrapper__background-screen"
	[type]="'transparent'"
>
	<ng-content></ng-content>
</plc-background-screen>
